var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLayer = function SvgIconLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.758 2.188 4.425 1.965c1.275.563 1.275 1.493 0 2.055L9.758 8.173c-.503.225-1.328.225-1.83 0L3.503 6.208c-1.275-.562-1.275-1.492 0-2.055l4.425-1.965c.502-.225 1.327-.225 1.83 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 8.25c0 .63.473 1.358 1.05 1.613l5.093 2.265c.39.172.832.172 1.214 0L14.7 9.862c.578-.255 1.05-.983 1.05-1.613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 12c0 .697.413 1.328 1.05 1.613l5.093 2.265c.39.172.832.172 1.214 0l5.093-2.265A1.77 1.77 0 0 0 15.75 12"
  })));
};
export default SvgIconLayer;